var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5001 5.5C15.5001 5.04 15.1276 4.66667 14.6668 4.66667C14.206 4.66667 13.8335 5.04 13.8335 5.5V7.41417L10.2993 3.29083C10.036 2.9825 9.58764 2.90916 9.23764 3.11916L5.68347 5.25167L1.97431 0.799998C1.67931 0.447498 1.15514 0.397498 0.799308 0.693331C0.446808 0.987498 0.398475 1.51333 0.692641 1.86666L4.85931 6.86666C5.12347 7.1825 5.57764 7.26 5.92931 7.0475L9.49181 4.91L12.8551 8.83333H10.5001C10.0393 8.83333 9.66681 9.20667 9.66681 9.66667C9.66681 10.1267 10.0393 10.5 10.5001 10.5H14.6668C14.7701 10.5 14.8726 10.4775 14.9701 10.4383C15.011 10.4225 15.0426 10.3958 15.0801 10.375C15.1235 10.3492 15.1701 10.3333 15.2085 10.2992C15.2168 10.2925 15.2201 10.2825 15.2276 10.275C15.2735 10.2333 15.3051 10.1825 15.3401 10.1317C15.3676 10.0917 15.4001 10.0567 15.4193 10.0133C15.4401 9.96916 15.4468 9.92 15.4585 9.8725C15.4743 9.81417 15.4918 9.7575 15.4935 9.6975C15.4943 9.68667 15.5001 9.6775 15.5001 9.66667V5.5Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.a69dc9f82c67465ecd6bf2196f1abe3e.svg";
export { ForwardRef as ReactComponent };